<template>
	<div class="orderInfoCover">
		<div class="orderDetailWrap">
			<h2>付款</h2>
			<!-- 购买详情 -->
			<h3>购买详情</h3>
			<div v-for="(item,index) in payInfo" :key="index">
				<!-- 章节购买 -->
				<ul v-if="item.resourceType == '情报内容'">
					<li>
						<div>
							<div class="nodeWrap">
								<span class="nodeText" :title="item.title">{{item.title}}</span>
								<span>{{'￥'+totalPrice}}</span>
							</div>
						</div>
					</li>
				</ul>
				<!-- 全书购买 -->
				<div class="allbook" v-else>
					<img :src="item.imagePath" alt="" />
					<div class="bookInfo">
						<h4>{{item.title}}</h4>
						<p>全书购买</p>
						<span>{{'￥'+totalPrice}}</span>
					</div>
				</div>
			</div>
			<!-- 订单详情 -->
			<h3>订单详情</h3>
			<div class="orderDetail">
				<p><span>订单编号：</span>{{orderDetail.id}}</p>
				<p><span>支付方式：</span>{{orderDetail.paymentWay}}</p>
				<p><span>支付时间：</span>{{orderDetail.creationDate}}</p>
				<p><span>实际付款：</span><strong>{{orderDetail.totalPrices}}</strong>（元）</p>
			</div>
			<span @click="CloseOrderDetail"></span>
		</div>
	</div>
</template>

<script>
import common from '../assets/js/common.js'
export default{
	data(){
		return{
			orderDetail:{},  // 订单详情
			payInfo:[],  // 支付信息
			totalPrice:0,  // 总价
		}
	},
	props:{
		// 支付信息
		id:{
			type:Number,
			default:undefined
		},
		// 订单号
		orderId:{
			type:Number,
			default:undefined
		}
	},
	mounted() {
		// 获取订单详情
		this.GetOrderDetail();
		// 获取支付信息
		this.GetPayInfo();
	},
	methods:{
		// 获取订单详情
		GetOrderDetail(){
			this.$fetch('/api/orderInfo/'+this.orderId)
			.then((res)=>{
				this.orderDetail = res.data;
				this.totalPrice = res.data.totalPrices;
			}).catch((err)=>{
				throw err;
			});
		},
		// 获取支付信息
		GetPayInfo(){
			this.$fetch('/api/goods/'+this.id+'/goodsDetails')
			.then((res)=>{
				this.payInfo = res.data;
			}).catch((err)=>{
				throw err;
			});
		},
		// 关闭章节购买
		CloseOrderDetail(){
			common.$emit('closeOrderDet');
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.orderInfoCover{
		width: 100%;
		height: calc(100% - .88rem);
		background: #F7F8FA;
	}
	.orderDetailWrap{
		width: 100%;
		padding: .5rem .25rem 0;
	}
	.orderDetailWrap h2,.orderDetailWrap>span{
		display: none;
	}
	/* 订单详情 */
	.orderDetail{
		width: 100%;
		border-radius: .24rem;
		padding: .3rem;
		background: #FFFFFF;
	}
	/* 购买详情 */
	.orderDetailWrap ul,.allbook{
		width: 100%;
		padding: .3rem;
		background-color: #FFFFFF;
		border-radius: .08rem .08rem 0 0;
	}
	/* 全书购买 */
	.allbook{
		display: flex;
		padding: .3rem;
	}
	.allbook img{
		width: 1.22rem;
		height: 1.62rem;
		margin-right: .2rem;
	}
	.allbook .bookInfo h4{
		font-size: .3rem;
		color: #424242;
		letter-spacing: 0;
		line-height: .36rem;
		margin: .16rem 0 .24rem;
	}
	.allbook .bookInfo p{
		font-size: .24rem;
		color: #919095;
		letter-spacing: 0;
		line-height: .24rem;
		margin-bottom: .3rem;
	}
	.allbook .bookInfo span{
		font-size: .24rem;
		color: #424242;
		letter-spacing: 0.69px;
	}
}
@media screen and (min-width: 1029px) {
	/* 订单信息弹窗 */
	.orderInfoCover{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.40);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}
	.orderDetailWrap{
		width: 520px;
		padding: 0 20px;
		background: #F7F8FA;
		background-image: linear-gradient(180deg, #BFE3FF 0%, rgba(231,245,255,0.00) 15%);
		border-radius: 8px;
		position: relative;
	}
	.orderDetailWrap h2{
		line-height: 60px;
		text-align: center;
		font-size: 14px;
		color: #333333;
	}
	/* 关闭 */
	.orderDetailWrap>span{
		position: absolute;
		top: 15px;
		right: 20px;
		display: block;
		width: 30px;
		height: 30px;
		background: url(../assets/img/detailsClose_icon.svg) no-repeat;
		cursor: pointer;
	}
	/* 订单详情 */
	.orderDetail{
		width: 480px;
		border-radius: 2px;
		padding: 24px 20px;
		box-sizing: border-box;
		margin: 0 auto;
		text-align: left;
		background: #FFFFFF;
		margin-bottom: 20px;
	}
	/* 购买详情 */
	.orderDetailWrap ul,.allbook{
		width: 100%;
		padding: 0 20px;
		background-color: #FFFFFF;
		border-radius: 4px;
	}
	/* 全书购买 */
	.allbook{
		display: flex;
		padding: 14px 20px;
	}
	.allbook img{
		width: 87px;
		height: 116px;
		margin-right: 13px;
	}
	.allbook .bookInfo h4{
		font-size: 18px;
		color: #424242;
		letter-spacing: 0;
		line-height: 30px;
	}
	.allbook .bookInfo p{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0;
		line-height: 14px;
		margin: 13px 0 37px;
	}
	.allbook .bookInfo span{
		font-size: 16px;
		color: #424242;
		letter-spacing: 0.69px;
	}
}
/* 订单信息弹窗 */
.orderDetailWrap h3{
	font-size: 14px;
	color: #919095;
	letter-spacing: 0.6px;
	line-height: 14px;
	margin: 20px 0 12px;
}
/* 购买详情 */
.nodeWrap{
	display: flex;
	justify-content: space-between;
	align-items: center;
	line-height: 40px;
}
.nodeWrap span{
	font-size: 12px;
	color: #424242;
	letter-spacing: 0.51px;
}
.nodeWrap .nodeText{
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
/* 订单详情 */
.orderDetail p{
	margin-top: 24px;
	font-size: 14px;
	color: #333333;
	line-height: 22px;
}
.orderDetail p:first-child{
	margin-top: 0;
}
.orderDetail p>span{
	color: #666666;
	margin-right: 14px;
	font-size: 14px;
}
.orderDetail strong{
	font-size: 20px;
	color: #CE5857;
	line-height: 28px;
	margin-right: 8px;
}
.orderDetail p:last-child{
	font-size: 12px;
	color: #333333;
	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrdersDetail.vue